import { Avatar, Menu } from '@mantine/core';
import { useFirestoreDocumentData } from '@react-query-firebase/firestore';
import { doc } from "firebase/firestore";
import React from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { FaceId, Logout, MoodHappy, NewSection } from 'tabler-icons-react';
import ChevronDownIcon from '../../assets/ChevronDownIcon';
import { auth, firestore } from '../../firebase';
import getDocument from '../../utils/useFirestoreDocument';

const DashboardMenu = ({setOpenProfile,handleQRSelfie,toggleLogout,createBoard}) => {
    const [ user ] = useAuthState(auth);

    const userRef = doc(firestore, `users`, user?.uid || "a");
    const userData = useFirestoreDocumentData(["user", user?.uid || "a"], userRef);

    const userAvatar = getDocument('users')?.getDocument?.data?.avatar;

    const firstName = userData?.data?.firstName;
    const lastName = userData?.data?.lastName;
    const userCredits = userData?.data?.credits;
    const initials = firstName?.split('')[0]+lastName?.split('')[0];

    return (
        <Menu 
            styles={{body: {width:'290px'}}}
            control={
                <div className="flex items-center gap-x-2">
                    {userAvatar
                    ? 
                        <Avatar size="md" radius="xl" src={`https://d2uqrxzbny1jco.cloudfront.net/fit-in/200x200/${userAvatar}`} alt="AvatarUser" />
                    : 
                        (!userAvatar && firstName && lastName 
                        ?
                            <Avatar color="blue" radius="xl" className="uppercase" size="md" src={null} alt="AvatarUser">{initials}</Avatar>
                        :
                            <Avatar color="blue" radius="xl" className="uppercase" size="md" src={null} alt="AvatarUser" />
                        )
                    }
                    {(firstName && lastName) && 
                    <h1 className="hidden md:block text-sm font-[500]">
                        <span className='capitalize'>{firstName}</span> <span className='capitalize'>{lastName}</span>
                    </h1>}
                    <ChevronDownIcon width={13} height={13} />
                </div>
            }>
                <Menu.Item onClick={createBoard} icon={<NewSection size={18}/>}>Crează o planșă ({userCredits} credite )</Menu.Item>
                <Menu.Label>Setari</Menu.Label>
                <Menu.Item onClick={() => setOpenProfile(true)} icon={<MoodHappy size={18} color={'black'}/>}>Profilul tău</Menu.Item>
                <Menu.Item onClick={() => handleQRSelfie()} icon={<FaceId size={18} color={'black'}/>}>Setează selfie</Menu.Item>
                <Menu.Item onClick={() => toggleLogout()} color="red" icon={<Logout size={18} color={'red'} />}>Deloghează-te</Menu.Item>
            </Menu>
    )
}

export default DashboardMenu;